import { render, staticRenderFns } from "./MiniTable.vue?vue&type=template&id=b228448c&"
import script from "./MiniTable.vue?vue&type=script&lang=ts&"
export * from "./MiniTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b228448c')) {
      api.createRecord('b228448c', component.options)
    } else {
      api.reload('b228448c', component.options)
    }
    module.hot.accept("./MiniTable.vue?vue&type=template&id=b228448c&", function () {
      api.rerender('b228448c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/MiniTables/MiniTable.vue"
export default component.exports